import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'protectiveFactors',
    label: 'Protective Factors',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
